import { type ReactElement, type ReactNode } from "react";

import { cn } from "../utils/cn";

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className }: EmptyStateProps): ReactElement {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center rounded-lg border border-dashed border-border-default bg-neutral-0 px-6 py-12 text-center",
        className,
      )}
    >
      {icon && (
        <div aria-hidden="true" className="mb-4 text-text-tertiary">
          {icon}
        </div>
      )}
      <div className="text-lg font-semibold text-text-primary">{title}</div>
      {description && (
        <p className="mt-2 max-w-md text-sm text-text-secondary">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
